import bee from "./Bee"
export default {
    name: "Advert",
    /*
        var query = {
            page: "",
            section: "",
            number_of_ads_to_load: ""
        }
    */
    /* eslint-disable no-unused-vars */
    load_adverts(query, success, fail) {
        bee.get({
            adverts: {
                _pg: query.number_of_ads_to_load,
                _w: [
                    [
                        [
                            ["platform", "e", "desktop_broswer"],
                            "AND",
                            ["page", "e", query.page]
                        ],
                        "AND",
                        ["section", "e", query.section]
                    ]
                ]
            }
        })
            .then(res => {
                if (success) {
                    var adds = res.adverts;
                    //nyd
                    //delete these dummy adds untill when admin can manage ads
                    adds = [{
                        id: 1,
                        media_url:
                            "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1600834572/botswana%20services/adverts/left_ads/slider_4_hnhms1.gif",
                        media_type: "image",
                        height: 400,
                        width: 300,
                        views_count: 0,
                        company_id: 34,
                        navigation_url: "https://youtube.com"
                    },
                    {
                        id: 2,
                        media_url:
                            "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1600837722/botswana%20services/adverts/left_ads/slider_2_eyhoox.jpg",
                        media_type: "image",
                        height: 400,
                        width: 300,
                        views_count: 0,
                        company_id: 54,
                        navigation_url: "https://live.com"
                    },
                    {
                        id: 3,
                        media_url:
                            "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601451573/botswana%20services/adverts/left_ads/ad_skin_care_nngw9o.jpg",
                        media_type: "image",
                        height: 400,
                        width: 300,
                        views_count: 0,
                        company_id: 54,
                        navigation_url: "https://google.com"
                    }];
                    //update the number of views of these adverts
                    var update_query = {
                        adverts: []
                    };
                    for (let index = 0; index < adds.length; index++) {
                        const ad = adds[index];
                        update_query.adverts.push({
                            views_count: parseInt(ad.views_count) + 1,
                            _w: [
                                ["id", "e", ad.id]
                            ]
                        });
                    }
                    if (update_query.adverts.length > 0) {
                        //we have some updates to push
                        bee.update(update_query).then(res2 => {
                            success(adds);
                        }).catch(errors2 => {
                            if (fail) {
                                fail(errors2);
                            }
                        });
                    } else {
                        success(adds);
                    }
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
            id: 0,
            page: "",
            section: "",
            user_id: 0,
            views_count: 0
        }
    */
    /* eslint-disable no-unused-vars */
    record_clicked_advert(query, success, fail) {
        bee.post({
            _julz: {
                _posts: [{
                    advert_click: {
                        advert_id: query.id,
                        user_id: query.user_id,
                        page: query.page,
                        section: query.section,
                        clicked_on: "1989-01-01",
                        _time_clicked_on_on_timestamp: "1989-01-01"
                    }
                }],
                _updates: [{
                    advert: {
                        views_count: parseInt(query.views_count) + 1,
                        _w: [
                            ["id", "e", query.id]
                        ]
                    }
                }]
            }
        }).then(res => {
            //console.log("This is it ", res);
            if(success){
                success(res.julz.posts[0].advert_click);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    }
}